export default __webpack_public_path__ + "static/montserrat-v15-latin-ext_latin-700-6a509a96f3c87d432524ffb374cb0fb7.woff";